import { render, staticRenderFns } from "./SalesPage.vue?vue&type=template&id=959dfeac&"
import script from "./SalesPage.vue?vue&type=script&lang=ts&"
export * from "./SalesPage.vue?vue&type=script&lang=ts&"
import style0 from "./SalesPage.vue?vue&type=style&index=0&id=959dfeac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports